import { render, staticRenderFns } from "./file-management.vue?vue&type=template&id=6e288806&scoped=true&"
import script from "./file-management.vue?vue&type=script&lang=js&"
export * from "./file-management.vue?vue&type=script&lang=js&"
import style0 from "./file-management.vue?vue&type=style&index=0&id=6e288806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e288806",
  null
  
)

export default component.exports